import { Route, Switch } from 'react-router-dom'
import { useRouter } from "../../hooks/router";
import { useEffect, useState, memo } from "react";

import NavBar from "../NavBar/NavBar";
import Header from "../Header/Header";
import Home from "../Pages/Home/Home";
import SearchPanel from "../Pages/Search/SearchPanel";
import Channels from "../Pages/Channels/Channels";
import Movies from "../Pages/Movies/Movies";
import TvShows from "../Pages/TvShows/TvShows";
import Favourites from "../Pages/Favourites/Favourites";
import InfoMovie from "../pages_child/InfoMovie/InfoMovie";
import Player from "../Pages/Player/Player";
import { get_highlighted, get_home, validate_token, get_not_read_messages_count } from "../../server/requests";
import SignUp from "../Auth/SignUp/SignUp";
import Settings from "../Pages/Settings/Settings";
import Lessons from '../Pages/Lessons/Lessons';
import Mobile from '../tablet_mobile/Mobile';
import Quiz from '../SubUsers/Quiz/Quiz';
import audio_source from '../Pages/Settings/sound/notification.mp3'
import socketIO from 'socket.io-client';
import { generate_id ,crypt,decrypt} from '../../components/Util/util';


export default memo(({
    network,
    configs,
    appSettings,
    isGuest
}) => {

    const user = localStorage.getItem('user') ? JSON.parse(decrypt('user', localStorage.getItem('user'))) : null
    const router = useRouter()
    const [continueWatchList, setContinueWatchList] = useState([])
    const [highlightedList, setHighlightedList] = useState([])
    const [showQuiz, setShowQuiz] = useState(true)
    const [listHome, setListHome] = useState([])
    const [showLoading, setShowLoading] = useState(false)
    const [windowWidth, setWindowWidth] = useState(false)
    const [adminReadAllMessages, setAdminReadAllMessage] = useState(0)
    const [notReadMessagesCount, setNotReadMessagesCount] = useState(0)

    useEffect(() => {
        if (window.innerWidth < 1000) {
            setWindowWidth(true)
        }
        if (!localStorage.getItem('device_id')) {
            let result = generate_id()
            localStorage.setItem('device_id', result)
        }
        window.addEventListener('resize', resizeWindow)

        const socket = socketIO.connect(process.env.REACT_APP_API_HOST || "https://demo-api.inorain.tv", { auth: { device_id: localStorage.getItem('device_id') } });

        socket.on("connect", function () { });

        socket.on("error", function name(params) {
            console.log(params, "ERRROR")

        })

        socket.on("connect_error", function (err) {
            console.log(err, "socket error");

        });
        socket.on("new_chat_message", function (data) {

            let _user = localStorage.getItem('user') ? JSON.parse(decrypt('user', localStorage.getItem('user'))) : null

            if (_user && _user.id == data.sub_id) {
                call_ringtone()
                let x = Math.random() * 100000
                setAdminReadAllMessage(x)
                get_unread_messages_count()
            }

        });
        socket.on("admin_read_chat_message", function (data) {
            let x = Math.random() * 100000
            console.log('admin read')
            // setAdminReadAllMessage(x)
        });
        get_unread_messages_count() // get unread messages count


        return () => {
            // socket.on("disconnect", function () { });
            window.removeEventListener("resize", resizeWindow);
        }

    }, [])

    const call_ringtone = () => {
        let _audio = new Audio();
        _audio.src = audio_source

        _audio.onload = function () {
            console.log('asdka.ms')
            _audio.play();
        }

        _audio.oncanplay = function () {
            console.log('canplay')
            _audio.play()
        }

        _audio.onerror = function () {
            console.log('error')
        }

        _audio.onended = function () {
            console.log('end')
        }


    }
    const get_unread_messages_count = () => {

        get_not_read_messages_count({}, res => {
            if (res.count > 0) {
                setNotReadMessagesCount(res.count)
            }
        }, err => { })
    }


    const resizeWindow = () => {

        if (window.innerWidth < 1000) setWindowWidth(true)

        else setWindowWidth(false)

    }

    useEffect(() => {

        if ((user && user.is_quiz_passed) || !appSettings.lessons) {
            setShowQuiz(true)
            setShowLoading(true)

            get_home({}, data => {

                let newArray = []
                let _continue = []
                for (let i = 0; i < data.length; i++) {

                    let row = {
                        id: i,
                        title: data[i].title,
                        type: data[i].type,
                        content: []
                    }

                    if (data[i].content.length) {
                        if (!_continue.length) {
                            _continue = data[i].content
                        }
                        for (let j = 0; j < data[i].content.length; j++) {
                            row.content.push(data[i].content[j])
                        }
                        newArray.push(row)
                    }

                    if (data[i].title == "Last added" && data[i].content.length) {
                        setContinueWatchList(data[i].content)
                    }

                }

                setListHome(newArray)
                setShowLoading(false)

                callbackGetHighlightedList(_continue)

            }, err => {
                if (err == 'Forbidden') {
                    if (router.query.token) {

                        validate_token({ token: router.query.token }, res => {
                            localStorage.setItem('token', crypt('token', router.query.token) )

                            if (router.query.a && router.query.token && router.query.userId && router.query.a == 'payment') {
                                router.push('/subusers' + '?a=' + router.query.a + "&userId=" + router.query.userId + "&token=" + router.query.token)
                            } else router.push('/subusers')

                        }, err => {
                            router.push('/auth')
                        })

                        // router.push('/auth?token=' + router.query.token)

                    }
                    else router.push('/auth')

                }
            })
        } else {
            setShowQuiz(false)
        }


    }, [showQuiz])

    const callbackGetHighlightedList = (_continue) => {
        get_highlighted({}, data => {

            if (data.length) setHighlightedList([...data])

            else if (_continue.length) setHighlightedList([_continue[0]])

        }, err => {

            if (_continue.length) setHighlightedList([_continue[0]])

        })
    }
    const callbackSetShowQuiz = (value) => {
        if (user) {
            user.is_quiz_passed = value
            localStorage.setItem('user', crypt('user', JSON.stringify(user)))
            setShowQuiz(value)
        }
    }

    return showQuiz ?
        (
            <>
                {
                    windowWidth ?
                        <>
                            {
                                router.pathname === '/settings' ?
                                    <>
                                        <NavBar
                                            isGuest={isGuest}
                                            notReadMessagesCount={notReadMessagesCount}
                                            appSettings={appSettings}
                                            configs={configs}
                                            NavClass={'navbar'}
                                        />
                                        <Switch>
                                            <Route path={'/settings'}>
                                                <Settings
                                                    isGuest={isGuest}
                                                    setNotReadMessagesCount={setNotReadMessagesCount}
                                                    notReadMessagesCount={notReadMessagesCount}
                                                    configs={configs}
                                                    adminReadAllMessages={adminReadAllMessages}
                                                    appSettings={appSettings}
                                                />
                                            </Route>
                                        </Switch>
                                    </>
                                    :
                                    <Mobile configs={configs} />

                            }

                        </>
                        :
                        <div className={'conteiner'}>
                            {router.pathname.split('/')[1] !== 'question' ?
                                <NavBar
                                    notReadMessagesCount={notReadMessagesCount}
                                    appSettings={appSettings}
                                    configs={configs}
                                    NavClass={'navbar'}
                                    isGuest={isGuest}
                                /> : null}
                            {
                                router.pathname.split('/')[1] !== 'search' &&
                                    router.pathname.split('/')[1] !== "movie" &&
                                    router.pathname.split('/')[1] !== 'player' &&
                                    router.pathname.split('/')[1] !== 'question' &&
                                    router.pathname.split('/')[1] !== 'settings' && router.pathname.split('/')[1] == '' ?
                                    <Header continueWatchList={highlightedList} />
                                    : null
                            }
                            <div
                                className={"main"} /*style={{top:router.pathname.split('/')[1] !== 'search'?'50%':'10rem',transition:'0 !important'}}*/>
                                <Switch>

                                    <Route exact path={'/'}>
                                        <Home
                                            showLoading={showLoading}
                                            listHome={listHome}
                                            isGuest={isGuest}
                                        />
                                    </Route>
                                    <Route path={'/search'}>
                                        <SearchPanel isGuest={isGuest} />
                                    </Route>
                                    <Route path={'/channels'}>
                                        <Channels isGuest={isGuest} />
                                    </Route>
                                    <Route path={'/lessons'} isGuest={isGuest} >
                                        <Lessons />
                                    </Route>
                                    <Route path={'/movies'} isGuest={isGuest}>
                                        <Movies />
                                    </Route>
                                    <Route path={'/tv-shows'} isGuest={isGuest}>
                                        <TvShows />
                                    </Route>
                                    <Route path={'/favourites'}>
                                        <Favourites isGuest={isGuest} />
                                    </Route>
                                    <Route path={'/settings'}>
                                        <Settings
                                            isGuest={isGuest}
                                            setNotReadMessagesCount={setNotReadMessagesCount}
                                            notReadMessagesCount={notReadMessagesCount}
                                            configs={configs}
                                            adminReadAllMessages={adminReadAllMessages}
                                            appSettings={appSettings}
                                        />
                                    </Route>
                                    <Route exact path="/movie/:id">
                                        <InfoMovie isGuest={isGuest} appSettings={appSettings}/>
                                    </Route>
                                    <Route path={'/player'}>
                                        <Player network={network} isGuest={isGuest} />
                                    </Route>
                                </Switch>
                            </div>
                        </div>
                }
            </>
        ) : <Quiz configs={configs} callbackSetShowQuiz={callbackSetShowQuiz} />
})